import { type FC } from "react";

import { Tab } from "@snapchat/snap-design-system";

import { MetricField } from "../../../gql-generated/types";
import { formatPercentValue } from "../../formatters";
import { useOrganicStats, useOrganicStatsTotal, useTimeRange } from "../../hooks";
import { ChartSkeletonContainer } from "../ChartSkeletonContainer";
import { InsightsSubTabs } from "../InsightsSubTabs";
import { SubTabContent } from "../SubTabContent";
import { SubTabHeader } from "../SubTabHeader";
import { BarChartComponent, LineChartComponent } from "../charts";

export const QualifiedLensPlaysSection: FC = () => {
    const { isAllTimeSelected } = useTimeRange();

    const { loading: chartsLoading, chartsMetrics } = useOrganicStats();
    const { loading: chartsTotalsLoading, totalMetrics } = useOrganicStatsTotal();

    return (
        <InsightsSubTabs>
            <Tab
                title={
                    <SubTabHeader
                        label="Long Plays"
                        tooltip="The total number of Lens Plays that are longer than 2 seconds"
                        statValue={totalMetrics?.[MetricField.LensLongPlays]?.totalValueFormatted ?? ""}
                        diffValue={totalMetrics?.[MetricField.LensLongPlays]?.diffValue}
                        loading={chartsTotalsLoading}
                    />
                }
            >
                <SubTabContent>
                    <ChartSkeletonContainer skeletonActive={chartsLoading}>
                        {chartsMetrics[MetricField.LensLongPlays] && (
                            <BarChartComponent
                                data={chartsMetrics[MetricField.LensLongPlays]}
                                contentName="Long Plays"
                            />
                        )}
                    </ChartSkeletonContainer>
                </SubTabContent>
            </Tab>
            {isAllTimeSelected ? undefined : (
                <Tab
                    title={
                        <SubTabHeader
                            label="Long Plays Ratio"
                            tooltip="The proportion of Long Plays over Total Plays"
                            statValue={totalMetrics?.[MetricField.LensLongPlayRatio]?.totalValueFormatted ?? ""}
                            diffValue={totalMetrics?.[MetricField.LensLongPlayRatio]?.diffValue}
                            loading={chartsTotalsLoading}
                        />
                    }
                >
                    <SubTabContent>
                        <ChartSkeletonContainer skeletonActive={chartsLoading}>
                            {chartsMetrics[MetricField.LensLongPlayRatio] && (
                                <LineChartComponent
                                    formatter={formatPercentValue()}
                                    data={chartsMetrics[MetricField.LensLongPlayRatio]}
                                    contentName="Long Plays Ratio"
                                />
                            )}
                        </ChartSkeletonContainer>
                    </SubTabContent>
                </Tab>
            )}
        </InsightsSubTabs>
    );
};
